export default __webpack_public_path__ + "static/media/games-img.06513f13.webp";